import React, { FC, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { Hyperlink } from '../../../components/Hyperlink';
import { USER_CURRENT_STATUS } from '../../../../../shared/constants/userStatusConstants';
import { ReportErrorModal } from '../report-error-modal/ReportErrorModal';
import { UserContext } from '../../../user/UserContext';
import { RestrictedModal } from '../../../components/modal/components/modal-restricted/RestrictedModal';
import { VerifyLawyerModal } from '../../../lawyer/verify-lawyer-modal/VerifyLawyerModal';
import { withModal, WithModalProps } from '../../../components/modal/withModal';
import { buildUrlWithParameters } from '../../../../admin/benchmarks/urlUtils';
import styles from './entity_infos_lawyer.module.scss';

type Props = {
  source: string;
  lawyerId: string;
  entityName: string;
} & WithModalProps;

export const RawEntityInfosLawyer: FC<Props> = ({
  openModal,
  source,
  entityName,
  lawyerId,
}) => {
  const {
    currentUser: { status, verified },
    loggedIn,
  } = useContext(UserContext);
  const uploadDecisionLinkParams = () => {
    if (!loggedIn) {
      return {
        onClick: () =>
          openModal(modalProps => (
            <RestrictedModal
              {...modalProps}
              title="Envoyez vos décisions pour gagner en visibilité"
              source="expertise_send_decision"
            />
          )),
      };
    }
    if (verified) {
      return {
        href: buildUrlWithParameters('/j/envoi', { source }),
      };
    }
    return {
      onClick: () =>
        openModal(modalProps => (
          <VerifyLawyerModal
            {...modalProps}
            lawyerName={entityName}
            lawyerId={lawyerId}
          />
        )),
    };
  };

  return (
    <>
      <Hyperlink className={styles.link} {...uploadDecisionLinkParams()}>
        <FormattedMessage id="entity/expertises/EntityInfosLawyer.tsx/1" />
      </Hyperlink>
      {status !== USER_CURRENT_STATUS.PRO_PLAN ? (
        ', '
      ) : (
        <FormattedMessage id="entity/expertises/EntityInfosLawyer.tsx/3" />
      )}
      <Hyperlink
        className={styles.link}
        onClick={() =>
          openModal(modalProps => (
            <ReportErrorModal
              {...modalProps}
              openModal={openModal}
              loggedIn={loggedIn}
              verified={verified}
              lawyerName={entityName}
              lawyerId={lawyerId}
            />
          ))
        }
      >
        <FormattedMessage id="entity/expertises/EntityInfosLawyer.tsx/2" />
      </Hyperlink>
      {status === USER_CURRENT_STATUS.PRO_PLAN && '.'}
    </>
  );
};

export const EntityInfosLawyer = withModal(RawEntityInfosLawyer);
